export default "__VITE_ASSET__Cx2w3k5V__"